import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { Lobby } from './pages/Lobby';
import { Game } from './pages/Game';
function App() {
    return (_jsx("div", { className: "min-h-screen bg-senior-bg", children: _jsxs(Routes, { children: [_jsx(Route, { path: "/", element: _jsx(Home, {}) }), _jsx(Route, { path: "/lobby", element: _jsx(Lobby, {}) }), _jsx(Route, { path: "/game/:gameId", element: _jsx(Game, {}) })] }) }));
}
export default App;
//# sourceMappingURL=App.js.map